// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconLocation = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 18,
    width: 12,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-location">
      <svg
        className="c-icon-location fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 12 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.90754 17.9957C2.81599 17.9957 0.293863 16.5879 0.0274244 14.7012C-0.0470271 14.1724 -0.0385841 12.4865 2.74368 11.4386L1.42813 9.88154C-1.8715 6.17414 0.919265 -0.164895 5.99118 0.00327976C11.0722 -0.126288 13.8539 6.15591 10.5534 9.88309C10.1328 10.3695 9.67385 10.9318 9.24635 11.4296C14.6123 13.6308 11.3993 18.1542 5.90762 17.996L5.90754 17.9957ZM3.58426 12.4325C-0.896661 13.8684 1.70994 16.8045 5.98672 16.7826C10.4415 16.7788 12.7616 13.8214 8.40451 12.4265C7.62392 13.3009 7.00607 14.1738 6.29835 14.8556H6.29759L6.29605 14.8572H6.29528L6.29298 14.8594L6.29145 14.8602L6.28914 14.8625L6.28838 14.861L6.28684 14.8625H6.28607C5.99826 15.0102 5.64289 14.9193 5.46328 14.6526C4.91602 14.0093 4.25277 13.225 3.58426 12.4325ZM4.26428 11.3445C4.26812 11.3483 5.98816 13.3812 5.99201 13.3856C7.30602 11.8346 8.38976 10.5511 9.61329 9.10389C12.2337 6.19429 10.0416 1.04412 6.00124 1.2154C1.95103 1.04719 -0.257307 6.17839 2.36856 9.10233C2.50749 9.2804 4.17227 11.2261 4.2636 11.3445H4.26428ZM5.99124 9.1904C1.56259 9.10781 1.60857 2.72179 5.99124 2.65138C10.4054 2.72942 10.3977 9.11378 5.99124 9.1904ZM5.99124 3.86371C3.22744 3.84325 3.18598 7.99009 5.99124 7.97807C8.77195 7.99322 8.77057 3.84703 5.99124 3.86293V3.86371Z" fill={fill || ''} />
      </svg>
    </Icon>
  );
};

export default IconLocation;
